module.exports = __webpack_public_path__ + "media/images/flags/32/British-Virgin-Islands-bcf20e33c1903595e8b083a2cc72ee17.png";